import { type GamePageContext } from "@/features/game/state";
import type { PreviewContent } from "../content/preview-content.types";
export type PreviewSearch = Readonly<
  Record<string, string | readonly string[] | undefined>
>;
export type FrontDoorData = {
  address: {
    url: string;
    corpus: string;
  };
  content: PreviewContent;
  isMember: boolean;
  inProgress: boolean;
  doorHref: string;
  canEdit: boolean;
  canReview: boolean;
};
export function searchStringOf(search: PreviewSearch): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(search)) {
    if (value === undefined) continue;

    for (const one of typeof value === "string" ? [value] : value)
      params.append(key, one);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
}
export function addressesOf({
  params,
  context,
}: {
  params: {
    coworld: string;
    league?: string;
  };
  context?: GamePageContext | undefined;
}) {
  const corpus = context?.corpusSlug ?? params.coworld;
  return params.league
    ? {
        url: `${params.coworld}/${params.league}`,
        corpus: `${corpus}/${params.league}`,
      }
    : { url: params.coworld, corpus };
}
export type FrontDoorViewerData = Pick<
  FrontDoorData,
  "isMember" | "inProgress" | "doorHref" | "canEdit" | "canReview"
>;
export type FrontDoorViewerResult = FrontDoorViewerData & {
  viewer:
    | import("@softmax/observatory-client/types").Schemas["WhoAmIResponse"]
    | null;
};
